import React from 'react';
import background_motion from './background_motion.mp4';
import styles from './Header.module.css';

const Header = () => {
     return (
          <div id="header" className={styles.container}>
               <video
                    className={styles.background_video}
                    src={background_motion}
                    autoPlay={true}
                    muted={true}
                    loop={true}
                    poster="https://i.ytimg.com/vi/3I_OPaUZdvg/maxresdefault.jpg"
               ></video>
               <div>
                    <p className={styles.text}>
                         Hello, I'm{' '}
                         <a
                              target="_blank"
                              rel="noreferrer"
                              href="https://www.linkedin.com/in/agustin-manuel-ojeda-916547239/"
                              className={styles.nameTitle}
                         >
                              Agustin Ojeda
                         </a>
                         .
                         <br /> I'm a full-stack developer.
                    </p>
                    <div className={styles.button_container}>
                         <a href="#about">
                              <button className={styles.button}>
                                   <span>View my work</span>
                              </button>
                         </a>
                    </div>
               </div>
          </div>
     );
};

export default Header;
